/* eslint-disable no-console */
import axios from 'axios';
import { BankType, BrandType, Country } from '../generated/graphql';

export type GetEventRouterClientConfig = {
  endpoint: string;
  isProd?: boolean;
  logOnly?: boolean;
};

export type TrackParams = {
  userId?: number;
  bank?: BankType;
  brand?: BrandType;
  country?: Country;
  payload?: Record<string, any>;
};

export const getEventRouterClient = (config: GetEventRouterClientConfig) => {
  const { endpoint, isProd = false, logOnly = false } = config;

  if (!endpoint) console.error('EventRouter Error: No endpoint defined');

  const track = async (eventName: string, params: TrackParams) => {
    const {
      userId, payload,
      bank = BankType.NoBank, brand = BrandType.Tranquiapp, country = Country.Co,
    } = params;

    if (!endpoint || !userId) return false;
    const formattedParams = {
      userId,
      event: eventName,
      properties: {
        ...payload,
        brand,
        bank,
        country,
        test_event: !isProd,
      },
    };

    if (logOnly) {
      console.log(`Track: ${JSON.stringify(formattedParams, null, 2)}`);
      return false;
    }

    try {
      const res = await axios.post(endpoint, formattedParams);
      console.log({ ...res.data, brand, bank, userId, eventName });
    } catch (e) {
      console.log('Error in track');
      return false;
    }
    return true;
  };

  return { track };
};
